import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { PricingPlanEnum } from 'src/app/enums/pricing-plan.enum';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionService {

    constructor(private http: HttpClient) { }

    private API_URL = environment.ApiUrl;

    public hasActiveSubscription(token, planPermissions?: Array<PricingPlanEnum>) {
        return this.http.get(`${this.API_URL}getuserfromtoken`, { headers: new HttpHeaders({ 'Authorization': `Bearer ${token}` }) }).pipe(
            catchError(() => of(false)),
            switchMap((data: any) => {
                //Administrator
                if (data.data?.user_role?.id_user_role == 1) {
                    return of(true);
                }
                //Subscription Active or Trialing
                const id_subscription_status = data.data?.subscription?.id_subscription_status;

                if (id_subscription_status == 3 || id_subscription_status == 4) {

                    if (!planPermissions) {
                        return of(true);
                    }

                    //Validar plan permissions
                    for (const planPermission of planPermissions) {
                        if (data.data?.subscription?.id_plan[planPermission] == 0) {
                            return of(false);
                        }
                    }

                    return of(true);
                }
                //Denied
                return of(false);
            })
        );
    }
}
